// components/ask-shift-button.js
// Rest + hover: signal icon + "Ask Shift" text label
// Active: radiating signal animation in gold
// Space only — Shift is silent until called.

import { useState } from 'react';

const radiateStyle = `
  @keyframes radiate {
    0% { opacity: 1; transform: scale(1); }
    100% { opacity: 0; transform: scale(1.8); }
  }
  @keyframes radiate-delay {
    0%, 30% { opacity: 0; transform: scale(1); }
    60% { opacity: 1; transform: scale(1); }
    100% { opacity: 0; transform: scale(1.8); }
  }
  .ask-shift-ring-outer { animation: radiate 1.6s ease-out infinite; transform-origin: 12px 12px; }
  .ask-shift-ring-inner { animation: radiate-delay 1.6s ease-out infinite; transform-origin: 12px 12px; }
`;

export default function AskShiftButton({ onAskShift, disabled, active }) {
  const [hover, setHover] = useState(false);

  const color = active ? '#c8a96e' : hover && !disabled ? '#7a9e82' : '#888888';

  return (
    <>
      {active && <style>{radiateStyle}</style>}
      <div
        onClick={disabled ? undefined : onAskShift}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        style={{
          display: 'flex', alignItems: 'center', gap: 6,
          cursor: disabled ? 'default' : 'pointer',
          opacity: disabled ? 0.35 : 1,
          userSelect: 'none',
        }}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={{ overflow: 'visible' }}>
          <circle cx="12" cy="12" r="2" fill={color} />
          <g className={active ? 'ask-shift-ring-inner' : undefined}>
            <path d="M8.5 8.5a5 5 0 0 0 0 7M15.5 8.5a5 5 0 0 1 0 7"
              stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
          </g>
          <g className={active ? 'ask-shift-ring-outer' : undefined}>
            <path d="M5.5 5.5a9 9 0 0 0 0 13M18.5 5.5a9 9 0 0 1 0 13"
              stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
          </g>
        </svg>
        <span style={{
          color,
          fontSize: 11,
          fontFamily: 'Georgia, serif',
          letterSpacing: '0.07em',
          transition: 'color 0.15s',
        }}>
          Ask Shift
        </span>
      </div>
    </>
  );
}